import MovementIcon from '../../../assets/milestoneChecker/movement.svg';
import SocialIcon from '../../../assets/milestoneChecker/social.svg';
import HearingIcon from '../../../assets/milestoneChecker/hearing.svg';
import HandsIcon from '../../../assets/milestoneChecker/hands.svg';
import TalkingIcon from '../../../assets/milestoneChecker/talking.svg';
import FeedingIcon from '../../../assets/milestoneChecker/feeding.svg';
import SelfCareIcon from '../../../assets/milestoneChecker/self-care.svg';
import ExclamationIcon from '../../../assets/milestoneChecker/exclamation.svg';

import twoWeeksMovementGif from '../../../assets/milestoneChecker/2Weeks/movement.webm';
import twoWeeksSocialGif from '../../../assets/milestoneChecker/2Weeks/social.webm';
import twoWeeksHearingGif from '../../../assets/milestoneChecker/2Weeks/hearing.webm';

import twoMonthsMovementGif from '../../../assets/milestoneChecker/2Months/movement.webm';
import twoMonthsSocialGif from '../../../assets/milestoneChecker/2Months/social.webm';
import twoMonthsTalkingGif from '../../../assets/milestoneChecker/2Months/talking.webm';
import twoMonthsHandsGif from '../../../assets/milestoneChecker/2Months/hands.webm';
import twoMonhtsWorryGif from '../../../assets/milestoneChecker/2Months/worry.webm';

import fourMonthsMovementGif from '../../../assets/milestoneChecker/4Months/movement.webm';
import fourMonthsSocialGif from '../../../assets/milestoneChecker/4Months/social.webm';
import fourMonthsTalkingGif from '../../../assets/milestoneChecker/4Months/talking.webm';
import fourMonthsHandsGif from '../../../assets/milestoneChecker/4Months/hands.webm';
import fourMonhtsWorryGif from '../../../assets/milestoneChecker/4Months/worry.webm';

import sixMonthsMovementGif from '../../../assets/milestoneChecker/6Months/movement.webm';
import sixMonthsFeedingGif from '../../../assets/milestoneChecker/6Months/feeding.webm';
import sixMonthsTalkingGif from '../../../assets/milestoneChecker/6Months/talking.webm';
import sixMonthsHandsGif from '../../../assets/milestoneChecker/6Months/hands.webm';
import sixMonhtsWorryGif from '../../../assets/milestoneChecker/6Months/worry.webm';

import nineMonthsMovementGif from '../../../assets/milestoneChecker/9Months/movement.webm';
import nineMonthsSocialGif from '../../../assets/milestoneChecker/9Months/social.webm';
import nineMonthsTalkingGif from '../../../assets/milestoneChecker/9Months/talking.webm';
import nineMonthsHandsGif from '../../../assets/milestoneChecker/9Months/hands.webm';
import nineMonhtsWorryGif from '../../../assets/milestoneChecker/9Months/worry.webm';

import twelveMonthsMovementGif from '../../../assets/milestoneChecker/12Months/movement.webm';
import twelveMonthsFeedingGif from '../../../assets/milestoneChecker/12Months/feeding.webm';
import twelveMonthsTalkingGif from '../../../assets/milestoneChecker/12Months/talking.webm';
import twelveMonthsHandsGif from '../../../assets/milestoneChecker/12Months/hands.webm';
import twelveMonhtsWorryGif from '../../../assets/milestoneChecker/12Months/worry.webm';

import fifteenMonthsSelfCareGif from '../../../assets/milestoneChecker/15Months/self-care.webm';
import fifteenMonthsHandsGif from '../../../assets/milestoneChecker/15Months/hands.webm';
import fifteenMonthsTalkingGif from '../../../assets/milestoneChecker/15Months/talking.webm';

import eighteenMonthsMovementGif from '../../../assets/milestoneChecker/18Months/movement.webm';
import eighteenMonthsSelfCareGif from '../../../assets/milestoneChecker/18Months/self-care.webm';
import eighteenMonthsHandsGif from '../../../assets/milestoneChecker/18Months/hands.webm';
import eighteenMonthsTalkingGif from '../../../assets/milestoneChecker/18Months/talking.webm';
import eighteenMonhtsWorryGif from '../../../assets/milestoneChecker/18Months/worry.webm';

import twoYearsMovementGif from '../../../assets/milestoneChecker/2Years/movement.webm';
import twoYearsSelfCareGif from '../../../assets/milestoneChecker/2Years/self-care.webm';
import twoYearsHandsGif from '../../../assets/milestoneChecker/2Years/hands.webm';
import twoYearsTalkingGif from '../../../assets/milestoneChecker/2Years/talking.webm';
import twoYearsWorryGif from '../../../assets/milestoneChecker/2Years/worry.webm';

import threeYearsMovementGif from '../../../assets/milestoneChecker/3Years/movement.webm';
import threeYearsSelfCareGif from '../../../assets/milestoneChecker/3Years/self-care.webm';
import threeYearsHandsGif from '../../../assets/milestoneChecker/3Years/hands.webm';
import threeYearsTalkingGif from '../../../assets/milestoneChecker/3Years/talking.webm';
import threeYearsWorryGif from '../../../assets/milestoneChecker/3Years/worry.webm';

import fourYearsMovementGif from '../../../assets/milestoneChecker/4Years/movement.webm';
import fourYearsSelfCareGif from '../../../assets/milestoneChecker/4Years/self-care.webm';
import fourYearsHandsGif from '../../../assets/milestoneChecker/4Years/hands.webm';
import fourYearsTalkingGif from '../../../assets/milestoneChecker/4Years/talking.webm';

import fiveYearsMovementGif from '../../../assets/milestoneChecker/5Years/movement.webm';
import fiveYearsHandsGif from '../../../assets/milestoneChecker/5Years/hands.webm';
import fiveYearsTalkingGif from '../../../assets/milestoneChecker/5Years/talking.webm';

import sixYearsMovementGif from '../../../assets/milestoneChecker/6Years/movement.webm';
import sixYearsHandsGif from '../../../assets/milestoneChecker/6Years/hands.webm';
import sixYearsTalkingGif from '../../../assets/milestoneChecker/6Years/talking.webm';

const milestones = Object.freeze([
  {
    id: 0,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: twoWeeksMovementGif,
      },
      {
        id: 1,
        icon: SocialIcon,
        gif: twoWeeksSocialGif,
      },
      {
        id: 2,
        icon: HearingIcon,
        gif: twoWeeksHearingGif,
      },
    ],
  },
  {
    id: 1,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: twoMonthsMovementGif,
      },
      {
        id: 1,
        icon: SocialIcon,
        gif: twoMonthsSocialGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: twoMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: twoMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: twoMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 2,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: fourMonthsMovementGif,
      },
      {
        id: 1,
        icon: SocialIcon,
        gif: fourMonthsSocialGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: fourMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: fourMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: fourMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 3,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: sixMonthsMovementGif,
      },
      {
        id: 1,
        icon: FeedingIcon,
        gif: sixMonthsFeedingGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: sixMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: sixMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: sixMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 4,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: nineMonthsMovementGif,
      },
      {
        id: 1,
        icon: SocialIcon,
        gif: nineMonthsSocialGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: nineMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: nineMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: nineMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 5,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: twelveMonthsMovementGif,
      },
      {
        id: 1,
        icon: FeedingIcon,
        gif: twelveMonthsFeedingGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: twelveMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: twelveMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: twelveMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 6,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: twelveMonthsMovementGif,
      },
      {
        id: 1,
        icon: SelfCareIcon,
        gif: fifteenMonthsSelfCareGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: fifteenMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: fifteenMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: twelveMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 7,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: eighteenMonthsMovementGif,
      },
      {
        id: 1,
        icon: SelfCareIcon,
        gif: eighteenMonthsSelfCareGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: eighteenMonthsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: eighteenMonthsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: eighteenMonhtsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 8,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: twoYearsMovementGif,
      },
      {
        id: 1,
        icon: SelfCareIcon,
        gif: twoYearsSelfCareGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: twoYearsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: twoYearsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: twoYearsWorryGif,
        type: 'danger',
      },
    ],
  },
  {
    id: 9,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: threeYearsMovementGif,
      },
      {
        id: 1,
        icon: SelfCareIcon,
        gif: threeYearsSelfCareGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: threeYearsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: threeYearsTalkingGif,
      },
      {
        id: 4,
        icon: ExclamationIcon,
        gif: threeYearsWorryGif,
        type: 'danger',
      },
    ],
  },

  {
    id: 10,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: fourYearsMovementGif,
      },
      {
        id: 1,
        icon: SelfCareIcon,
        gif: fourYearsSelfCareGif,
      },
      {
        id: 2,
        icon: HandsIcon,
        gif: fourYearsHandsGif,
      },
      {
        id: 3,
        icon: TalkingIcon,
        gif: fourYearsTalkingGif,
      },
    ],
  },
  {
    id: 11,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: fiveYearsMovementGif,
      },

      {
        id: 1,
        icon: HandsIcon,
        gif: fiveYearsHandsGif,
      },
      {
        id: 2,
        icon: TalkingIcon,
        gif: fiveYearsTalkingGif,
      },
    ],
  },
  {
    id: 12,
    options: [
      {
        id: 0,
        icon: MovementIcon,
        gif: sixYearsMovementGif,
      },
      {
        id: 1,
        icon: HandsIcon,
        gif: sixYearsHandsGif,
      },
      {
        id: 2,
        icon: TalkingIcon,
        gif: sixYearsTalkingGif,
      },
    ],
  },
]);

export default milestones;
